<div class="d-flex pb-2 flex-column h-100" style="min-width: 960px">
  <div class="d-flex bgcomp flex-column mh-100">
    <div>
      <div class="d-flex mx-3 pt-3">
        <app-keyword-search
          (keywords)="onUpdatingKeywords($event)"
          [currentSiteChangedEvent]="clearSearch$"
        ></app-keyword-search>
        <div class="ml-3 mr-auto">
          <button
            mat-button
            mat-stroked-button
            (click)="createNewOrder()"
            id="createNewOrder"
            class="px-3"
            *ngIf="isOrderFormEnabled$ | async"
          >
            <mat-icon class="mr-1">add_circle_outline</mat-icon>
            Create New Order
          </button>
        </div>
        <div *ngIf="filtersApplied$ | async" class="clear-filter-box">
          <button mat-stroked-button (click)="clearFilters()">
            <mat-icon>delete_outline</mat-icon>
            Clear Filters
          </button>
        </div>
        <div class="mx-3 date-filter-box">
          <app-date-range-picker
            [initialRangeValue]="timeRangeFilter$ | async"
            (selectedRangeValueChange)="filterTimeRangeChange($event)"
          >
          </app-date-range-picker>
        </div>
        <div>
          <button
            type="button"
            class="px-4"
            mat-stroked-button
            (click)="openFilters()"
          >
            Filters
          </button>
          <app-worklist-filters
            [visible]="filtersVisible$ | async"
            (closePopout)="closeFilters()"
          ></app-worklist-filters>
        </div>
      </div>
    </div>
    <div class="my-2 mx-3">
      <hr class="container-divider" *ngIf="!loading" />
      <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
    </div>
    <div
      *ngIf="worklistItems$ | async as worklistItems; else loadingTemplate"
      class="mx-0 mb-3 d-flex flex-grow-1 overflow-fix"
    >
      <app-data-table
        [worklistItems]="worklistItems"
        [selectedItem]="selectedItem$ | async"
        [filtersApplied]="filtersApplied$ | async"
        class="flex-grow-1 custom-scrollbar overflow-auto px-3"
        (openRow)="openDetails($event)"
        (visualRowSizeChanged)="onVisualRowSizeChanged($event)"
      ></app-data-table>
      <app-worklist-details
        *ngIf="selectedItem$ | async as selectedItem"
        class="overflow-auto"
        [worklistItem]="selectedItem"
        (updateItemUrgency)="onUpsertWorklistItem($event)"
        (closePane)="closeDetails()"
      ></app-worklist-details>
    </div>
    <ng-template #loadingTemplate>
      <div class="mx-0 mb-3 d-flex flex-grow-1 overflow-fix">
        <app-data-table class="flex-grow-1 overflow-auto px-3"></app-data-table>
      </div>
    </ng-template>
  </div>
</div>
